import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTRouteTypeInsertRequest } from "../shared/BTRouteTypeInsertRequest";
import { BTRouteTypeUpdateRequest } from "../shared/BTRouteTypeUpdateRequest";
import { DataService_BusTrackerRouteType } from "../shared/data.service";

@Component({
	selector: "app-bus-route-type-modify",
	templateUrl: "./bus-route-type-modify.component.html",
	styleUrls: ["./bus-route-type-modify.component.css"],
})
export class BusRouteTypeModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private RouteTypeService: DataService_BusTrackerRouteType
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.Imported = this.dialogConfig.data.Imported;

		if (this.EditMode == true) {
			this.BusRouteTypeID = this.dialogConfig.data.BusRouteTypeID;
			this.BusRouteTypeNbr = this.dialogConfig.data.BusRouteTypeNbr;
			this.BusRouteTypeDesc = this.dialogConfig.data.BusRouteTypeDesc;
		}
	}

	//////////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////////

	EditMode: any = false;
	Imported: any = false;
	BusRouteTypeID: any = -1;
	BusRouteTypeNbr: any = "";
	BusRouteTypeDesc: any = "";

	errorMessage: any = "";

	//////////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		if (this.BusRouteTypeNbr == "") {
			this.errorMessage = "Enter a Route Type Code";
			return;
		}
		if (this.BusRouteTypeDesc == "") {
			this.errorMessage = "Enter a Route Type Name/Description";
			return;
		}

		//
		// Create Request
		//
		let parms: BTRouteTypeInsertRequest = {
			BusRouteTypeNbr: this.BusRouteTypeNbr,
			BusRouteTypeDesc: this.BusRouteTypeDesc,
			DefinedByID: 4,
		};

		//
		// Call SP
		//
		var result = this.RouteTypeService.RouteTypeInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route Type was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the Route Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onUpdate() {
		this.errorMessage = "";

		if (this.BusRouteTypeNbr == "") {
			this.errorMessage = "Enter a Route Type Code";
			return;
		}
		if (this.BusRouteTypeDesc == "") {
			this.errorMessage = "Enter a Route Type Name/Description";
			return;
		}

		//
		// Create Request
		//
		let parms: BTRouteTypeUpdateRequest = {
			BusRouteTypeID: this.BusRouteTypeID,
			BusRouteTypeNbr: this.BusRouteTypeNbr,
			BusRouteTypeDesc: this.BusRouteTypeDesc,
		};

		//
		// Call SP
		//
		var result = this.RouteTypeService.RouteTypeUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Route Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Route Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	//////////////////////////////////////////////////////////////////////////////////
}
